<template>
  <div style="display: flex;">
    <div class="left-tree">
      <div style="display: flex;align-items: center;position: sticky;top: 0;background: #ffffff;z-index: 1;padding: 40px 0 20px 0;">
        <el-input
          v-model="searchKey"
          placeholder="请输入关键字搜索部门"
          clearable
          size="small"
          style="flex: 1;"
        />
        <el-button type="primary" size="mini" @click="filterTree" style="margin-left: 10px;">搜索</el-button>
      </div>
      <el-tree
        ref="tree"
        node-key="id"
        :data="treeData"
        default-expand-all
        :props="defaultProps"
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
      ></el-tree>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="botton-box">
          <!-- <el-button
            size="mini"
            v-if="formData.deptId"
            @click="getchildeditDialog"
            class="addButton"
            >添加</el-button
          > -->
          <el-button
            size="mini"
            @click="resetTree"
            class="addButton"
            >重置</el-button
          >
        </div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="真实姓名">
                <el-input
                  v-model="form.userName"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入真实姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="登录账号">
                <el-input
                  v-model="form.accountName"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入登录账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input
                  v-model="form.phone"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="部门">
                <el-cascader
                  :props="props"
                  v-model="form.deptId"
                  :options="deptTree"
                  @change="queryhandleChange"
                  :show-all-levels="false"
                  filterable
                  class="xiugai"
                  clearable
                ></el-cascader>
              </el-form-item> -->
              <el-form-item label="角色">
                <el-select
                  filterable
                  style="width: 150px"
                  size="mini"
                  placeholder="请选择角色"
                  clearable
                  v-model="form.roleId"
                >
                  <el-option
                    v-for="item in roleData"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="用户类型">
                <el-select
                  style="width: 150px"
                  filterable
                  size="mini"
                  placeholder="请选择用户类型"
                  clearable
                  v-model="form.userType"
                >
                  <el-option
                    v-for="item in userTypeList"
                    :key="item.itemLabel"
                    :label="item.itemName"
                    :value="item.itemLabel"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="状态">
                <el-select
                  style="width: 150px"
                  filterable
                  size="mini"
                  placeholder="请选择用户类型"
                  clearable
                  v-model="form.status"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.itemLabel"
                    :label="item.itemName"
                    :value="item.itemLabel"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form-item">
                <el-button
                  type="primary"
                  @click="onSearch"
                  class="search"
                  style="margin-right: 20px;"
                  size="mini"
                  >查询</el-button
                >
              </el-form-item>
              <el-form-item class="form-item">
                <el-button
                  type="primary"
                  @click="onReset"
                  class="search"
                  size="mini"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="disTable"
              ref="multipleTable"
              align="center"
              max-height="650"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center'
              }"
              :cell-style="{ textAlign: 'center' }"
              :data="tableData"
              @selection-change="handleSelectionChange"
            >
              <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
              <el-table-column
                align="center"
                prop="userName"
                label="真实姓名"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="accountName"
                label="用户登录账号"
              ></el-table-column>
              <el-table-column align="center" prop="deptName" label="部门">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.deptName"
                    placement="top"
                  >
                    <span>{{ scope.row.deptName }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="zcWorkPosition"
                label="职务"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.zcWorkPosition }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span>{{ phoneNumbe(scope.row.phone) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="zcUserType"
                label="人员类型"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.zcUserType == 'gov'">政务人员</span>
                  <span v-if="scope.row.zcUserType == 'gov-street'"
                    >街道工作人员</span
                  >
                  <span v-if="scope.row.zcUserType == 'gov-community'"
                    >社区工作人员</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="zcWorkStatus"
                label="工作状态"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.zcWorkStatus == 'on'">在职</span>
                  <span v-if="scope.row.zcWorkStatus == 'off'">离职</span>
                  <span v-if="scope.row.zcWorkStatus == 'transferred'"
                    >调离</span
                  >
                  <span v-if="scope.row.zcWorkStatus == 'retired'">休假</span>
                  <span v-if="scope.row.zcWorkStatus == 'sick'">病休</span>
                  <span v-if="scope.row.zcWorkStatus == 'retire'">退休</span>
                </template>
              </el-table-column>

              <el-table-column prop="zxRoleNames" label="平台角色">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.zxRoleNames && scope.row.zxRoleNames.toString()
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="zcRoleNames" label="客服角色">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.zcRoleNames && scope.row.zcRoleNames.toString()
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <div v-for="(item, index) in statusOptions" :key="index">
                    <div v-if="scope.row.status == item.itemLabel">
                      {{ item.itemName }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column label="操作" fixed="right" width="280">
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px; color: #3666EA"
                    type="text"
                    @click="getUserDetailFun(scope.row.id)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    @click="relation(scope.row)"
                    style="margin-left: 10px; color: #3666EA"
                    >角色绑定</el-button
                  >
                  <el-popconfirm
                    title="确定删除吗？"
                    type="text"
                    trigger="click"
                    @confirm="deleteType(scope.row)"
                  >
                    <el-button
                      type="text"
                      slot="reference"
                      style="margin-left: 10px; color: #ed6363"
                      >删除</el-button
                    >
                  </el-popconfirm>
                  <el-dropdown style="margin-left: 10px; color: #3666EA">
                    <span
                      class="el-dropdown-link"
                      style="color: rgb(11, 111, 246)"
                      >更多</span
                    >
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <el-popconfirm
                          title="确定重置吗？"
                          trigger="click"
                          style="color: #3666EA"
                          @confirm="resetPassword(scope.row)"
                        >
                          <el-button
                            style="margin-left: 10px; color: #3666EA"
                            type="text"
                            slot="reference"
                            >重置密码</el-button
                          >
                        </el-popconfirm>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          style="margin-left: 10px; color: #3666EA"
                          type="text"
                          v-if="scope.row.openId"
                          @click="seeOpenId(scope.row)"
                          >查看openId</el-button
                        >
                      </el-dropdown-item>
                      <!-- <el-dropdown-item>
                        <el-button
                          style="margin-left: 10px; color: #3666EA"
                          type="text"
                          @click="shouquan(scope.row)"
                        >
                          <div v-if="scope.row.openId">取消授权</div>
                          <div v-else>免密授权</div>
                        </el-button>
                      </el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            :page-size="page.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="user-form">
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          label-position="top"
        >
          <el-form-item prop="accountName" label="登录名">
            <el-input
              v-model="formData.accountName"
              placeholder="登录名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="userName" label="真实姓名">
            <el-input
              v-model="formData.userName"
              placeholder="真实姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="登录密码" v-if="isWord" prop="password">
            <el-input
              type="password"
              :disabled="isdisabled"
              v-model="formData.password"
              placeholder="登录密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="deptId" label="部门" class="tree-d">
            <el-cascader
              :props="props"
              v-model="formData.deptId"
              :options="deptTree"
              @change="handleChange"
              :show-all-levels="false"
              filterable
              style="width: 364px;"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="formData.phone" placeholder="手机号"></el-input>
          </el-form-item>
          <!-- 添加填写项 -->
          <!-- <el-form-item label="证件类型">
            <el-select
              filterable
              placeholder="请选择证件类型"
              clearable
              v-model="formData.idType"
            >
              <el-option label="身份证" value="1"></el-option>
              <el-option label="护照" value="2"></el-option>
              <el-option label="户口簿" value="3"></el-option>
              <el-option label="军人证" value="4"></el-option>
              <el-option label="港澳台居民身份证" value="5"></el-option>
              <el-option label="武警身份证" value="6"></el-option>
              <el-option label="边民出入境通行证" value="7"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="身份证号" prop="idcardNum">
            <el-input v-model="formData.idNo" placeholder="身份证号"></el-input>
          </el-form-item> -->
          <el-form-item prop="email" label="邮箱">
            <el-input v-model="formData.email" placeholder="邮箱"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="userType" label="用户类型">
            <el-input
              v-model="formData.ghUserType"
              placeholder="用户类型"
            ></el-input>
          </el-form-item> -->

          <el-form-item label="工作状态">
            <el-select
              filterable
              placeholder="请选择工作状态"
              clearable
              v-model="formData.zcWorkStatus"
            >
              <el-option label="在职" value="on"></el-option>
              <el-option label="离职" value="off"></el-option>
              <el-option label="调离" value="transferred"></el-option>
              <el-option label="休假" value="retired"></el-option>
              <el-option label="病休" value="sick"></el-option>
              <el-option label="退休" value="retire"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职务">
            <el-select
              filterable
              placeholder="请选择职务"
              clearable
              v-model="formData.zcWorkPosition"
            >
              <el-option
                v-for="(item, index) in positionOptions"
                :key="index"
                :label="item.data.itemName"
                :value="item.data.itemName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员类型">
            <el-select
              filterable
              placeholder="请选择人员类型"
              clearable
              v-model="formData.zcUserType"
            >
              <el-option label="政务人员" value="gov"></el-option>
              <el-option label="街道工作人员" value="gov-street"></el-option>
              <el-option label="社区工作人员" value="gov-community"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主要工作">
            <el-input
              v-model="formData.zcMainDuty"
              placeholder="主要工作"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="formData.eiZfFlag == 1" label="执法证号">
            <el-input
              v-model="formData.eiZfzh"
              placeholder="执法证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="formData.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          class="search"
          size="mini"
          @click="cancelcerat"
        >
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
    <!--    重置密码-->
    <el-dialog
      title="重置密码"
      width="30%"
      :modal="true"
      :visible.sync="passwordVisible"
    >
      <div class="word">
        <div>新密码：{{ passwordForm.password }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passwordVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="角色绑定"
      width="800px"
      :modal="true"
      class="user-dialog"
      :close-on-click-modal="false"
      :visible.sync="isformPermission"
    >
      <el-form
        class="guanlian"
        ref="ruleForm"
        :rules="rules"
        :inline="true"
        :model="formPermission"
      >
        <span class="roleLabel">平台角色：</span>
        <el-transfer
          @change="roleChange"
          v-model="roleValue"
          :data="roleDatag"
          :titles="['所有角色列表', '授权角色列表']"
        ></el-transfer>
        <span class="roleLabel">客服角色：</span>
        <el-transfer
          @change="roleChange"
          v-model="roleValue"
          :data="roleDatag2"
          :titles="['所有角色列表', '授权角色列表']"
        ></el-transfer>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isformPermission = false">取 消</el-button>
        <el-button type="primary">
          <span @click="setRole">确 定</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="userInfo"
      title="查看用户信息"
      :visible.sync="visible"
      width="800"
      :close-on-click-modal="false"
    >
      <el-form
        :model="viewFormData"
        :rules="rules"
        :inline="true"
        label-width="100px"
        ref="formInbasic"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="登录名">
              <div>{{ viewFormData.accountName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="真实姓名">
              <div>{{ viewFormData.userName }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="登录密码">
              <div>{{ viewFormData.password }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="部门" class="tree-d">
              <div v-for="(item, index) in DepartmentList" :key="index">
                <div v-if="item.id == viewFormData.deptId">
                  {{ item.value }}
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="10">
            <el-form-item label="用户类型">
              <div v-for="(item, index) in userTypeList" :key="index">
                <div v-if="item.value == viewFormData.userType">
                  {{ item.label }}
                </div>
              </div>
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="用户状态">
              <div
                v-for="(item, index) in statusOptions"
                :key="index"
                v-if="viewFormData.status != null"
              >
                <div v-if="item.dictValue == viewFormData.status">
                  {{ item.dictLabel }}
                </div>
              </div>
              <!--              <div v-else>{{暂无数据}}</div>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="手机号">
              <div v-if="viewFormData.phone">{{ viewFormData.phone }}</div>
              <!--              <div v-else>{{暂无数据}}</div>-->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="身份证号">
              <div v-if="viewFormData.idNo">{{ viewFormData.idNo }}</div>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="岗位">
              <div v-if="viewFormData.remark">{{ viewFormData.remark }}</div>
              <!--              <div v-else>{{暂无数据}}</div>-->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="邮箱">
              <div v-if="viewFormData.email">{{ viewFormData.email }}</div>
              <!--              <div v-else>{{暂无数据}}</div>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看openId"
      width="800px"
      :modal="true"
      class="user-dialog"
      :close-on-click-modal="false"
      :visible.sync="openIdvisible"
    >
      <div>{{ openId }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini">
          <span @click="openIdvisible = false">确 定</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserList2,
  setUserSave,
  getDeptArray,
  getRoleArray,
  UserSwitch,
  getDeptTree,
  setUserRole,
  getUserDetail,
  downloadFile,
  expUserList,
  dictItemRoot
} from "@/api/systemManagement";
import { setUserReset, userType } from "../../../api/systemManagement";
import CryptoJS from "crypto-js";

export default {
  data() {
    const _self = this;
    return {
      searchKey: '',
      roleDatag: [],
      roleDatag2: [],
      ser: [],
      isWord: true,
      visible: false,
      isdisabled: false,
      deptTree: [],
      roleValue: [],
      openIdvisible: false,
      recoveryList: [],
      toJdyList: [],
      DepartmentList: [],
      tableDataTwo: [],
      roleList: [],
      roleData: [],
      isformPermission: false,
      dialogVisibleTwo: false,
      currentPageTwo: "1",
      relationUser: false,
      dialogVisible: false,
      passwordVisible: false,
      formPermission: {
        id: null,
        roleIds: [],
        roleIds2: []
      },
      totalTwo: "",
      statusOptions: [],
      userTypeList: [],
      ruleForm: {
        accountName: "",
        userName: "",
        password: "",
        deptId: "",
        // userType: "",
        phone: "",
        idNo: null,
        email: "",
        remark: "",
        status: 1,
        id: ""
      },
      passwordForm: {
        password: ""
      },
      entryList: [],
      optionList: [],
      total: null,
      title: "添加用户",
      titleTwo: "查看配置基本信息",
      currentPage: 1,
      form: {
        deptId: "",
        accountName: "",
        roleId: "",
        userName: "",
        phone: "",
        status: null
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      formData: {
        accountName: "",
        idType: "",
        zcUserType: "",
        zcWorkStatus: "",
        zcUserType: "",
        zcWorkPosition: "",
        zcMainDuty: "",
        userName: "",
        password: "",
        deptId: "",
        ghUserType: "",
        userType: "1",
        phone: "",
        idNo: null,
        email: "",
        remark: "",
        eiZfzh: "",
        eiUserType: "",
        status: 1,
        eiZfFlag: 0,
        id: null
      },
      viewFormData: {
        status: null,
        accountName: null,
        userName: null,
        password: null,
        deptId: null,
        mail: null,
        idNo: null,
        phone: null,
        userType: null,
        remark: null
      },
      openId: "",
      key: "u9dYuYlGVk39kkb5",
      pageTwo: {
        page: 1,
        size: 10
      },
      choiceList: [],
      rules: {
        accountName: [
          { required: true, message: "请输入登录账号", trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
          // {
          //   required: true,
          //   message: '请输入邮箱地址',
          //   trigger: 'blur',
          // },
        ],
        deptId: [{ required: true, message: "请选择部门", trigger: "blur" }],
        // phone: [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        // ],
        // userType: [
        //   { required: true, message: "请选择用户类型", trigger: "blur" }
        // ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
            pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,12}$/,
            message:
              "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！"
          }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        old: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        towPassword: [
          { required: true, message: "再次确认新密码", trigger: "blur" }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ]
      },
      props: {
        value: "id",
        label: "label",
        children: "children",
        checkStrictly: true,
        lazy: false, //设置lazyLoad，必须配合lazy：true
        async lazyLoad(node, resolve) {
          // 区域树懒加载的方法
          const { data } = node;
          if (
            (data && data.haveSon === false) ||
            (data && data.leaf === true)
          ) {
            return resolve([]);
          }
          let id;
          if (data) {
            id = data.id;
          } else {
            return resolve([]);
          }
          const temp = await _self.getSta(id);
          for (const item of temp.data) {
            item.leaf = item.level === "city";
          }
          resolve(temp.data);
        }
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      treeData: [],
      curdeptId: "",
      positionOptions: []
    };
  },
  mounted() {
    this.queryDictionaries();
    this.dictItemRootFun();
    // this.getDepartment()
    this.getrole();
    this.getTree();
    this.getUserType();
    this.getUserStatus();
  },
  computed: {
    phoneNumbe() {
      return function(phone) {
        if (!phone) return;
        // 手机号仅显示前三位及后四位数字，隐藏信息用*代替
        return phone.substr(0, 3) + "****" + phone.substring(7);
      };
    },
    idNoNumbe() {
      return function(idNo) {
        if (!idNo) return;
        return idNo.substr(0, 3) + "****" + idNo.substring(14);
      };
    }
  },
  watch: {
    // dialogVisible(val){
    //   if (val == false) {
    //     this.$refs['ruleForm'].resetFields();
    //   }
    // }
  },
  methods: {
    resetTree () {
      this.searchKey = '';
      this.filterTree();
    },
    // 过滤树节点（el-tree 内置方法）
    filterNode(value, data) {
      if (!value) return true; // 无关键字时显示所有节点
      return data.label.includes(value); // 按标签匹配关键字
    },
    // 输入框变化时触发过滤
    filterTree() {
      console.log(this.searchKey);
      this.$refs.tree.filter(this.searchKey);
    },
    async dictItemRootFun() {
      const { data } = await dictItemRoot({
        dictType: "ZC_WORK_POSITION",
        data: true,
        pid: -1,
        page: 1,
        size: 9999
      });
      this.positionOptions = data.data.dataList || [];
    },
    handleChange(val) {
      this.formData.deptId = val[val.length - 1];
    },
    handleNodeClick(value) {
      this.form.deptId = value.id;
      this.curdeptId = value.id;
      this.formData.deptId = this.curdeptId;
      this.onSearch();
    },
    async getSta(pid) {
      const params = {
        name: "",
        id: "",
        pid: pid
      };
      const data = await getDeptTree(params);
      return data.data;
    },
    seeOpenId(val) {
      this.$axios
        .get(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/user/query/openId/${val.id}`
        )
        .then(res => {
          this.openId = res.data.data;
          this.openIdvisible = true;
        });
    },
    shouquan(val) {
      this.$axios
        .get(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/user/openId/${val.id}`
        )
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.queryDictionaries();
          } else {
            this.$message({
              message: `${res.data.msg}`,
              type: "warning"
            });
          }
        });
    },
    async recovery() {
      let stus = true;
      let recove = [];
      this.recoveryList.map(item => {
        if (item.status !== 3) {
          stus = false;
        } else {
          recove.push(item.id);
        }
      });
      if (stus == false) {
        this.$message({
          message: "只能恢复状态为删除的用户!",
          type: "warning"
        });
        return false;
      }
      let params = {
        ids: recove,
        status: 1
      };
      let res = await setUserReset(params);
      if (res.data.code == 200) {
        this.$message({
          message: "恢复成功",
          type: "success"
        });
        this.queryDictionaries();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    encryptByAES(message, key) {
      var iv = "LT0cYheDsyKGHENw";
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var ivHex = CryptoJS.enc.Utf8.parse(iv);
      var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    // onroleId(val){
    //   console.log(val)
    // },
    async getUserStatus() {
      this.$axios
        .get(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/dict/item/user_status`
        )
        .then(res => {
          this.statusOptions = res.data.data;
        });
    },
    async getUserType() {
      this.$axios
        .get(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/dict/item/user_type`
        )
        .then(res => {
          res.data.data.map(item => {
            this.userTypeList.push({
              itemLabel: Number(item.itemLabel),
              itemName: item.itemName
            });
          });
        });
    },
    roleChange(val, val2, val3) {
      console.log(val, val2, val3);

      if (val2 == "left") {
        this.roleValue = this.roleValue.filter(item => !val3.includes(item));
      } else {
        this.roleValue = this.roleValue.concat(val3);
      }
      this.roleValue = Array.from(new Set(this.roleValue));
      console.log(this.roleValue, "this.roleValue");
    },
    relation(val) {
      this.ser = [];
      this.roleValue = [];
      this.roleDatag = [];
      // console.log(this.roleData, "this.roleData");
      this.roleDatag = this.roleData.filter(item => item.type == 1) || [];
      this.roleDatag2 = this.roleData.filter(item => item.type == 3) || [];
      this.roleDatag.map(item => {
        item.disabled = false;
      });
      this.$axios
        .get(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/role/user/${val.id}`
        )
        .then(res => {
          if (res.data.code == 200) {
            res.data.data.map(item => {
              this.ser.push(item);
              this.roleValue.push(item.id);
            });
            this.ser.map(item => {
              this.roleDatag.map(iter => {
                if (item.id == iter.key) {
                  if (item.type == 1) {
                    iter.disabled = false;
                  } else {
                    iter.disabled = true;
                  }
                }
              });
            });
          }
        });
      this.formPermission.id = val.id;
      this.isformPermission = true;
    },
    async setRole() {
      let params = {
        id: this.formPermission.id,
        roleIds: this.roleValue
      };
      const res = await setUserRole(params);
      if (res.data.code == 200) {
        this.$message({
          message: "角色绑定成功",
          type: "success"
        });
        this.roleValue = [];
        this.isformPermission = false;
        this.queryDictionaries();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    resetPassword(val) {
      this.$axios
        .get(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/user/reset/${val.id}`
        )
        .then(res => {
          if (res.data.code == 200) {
            this.passwordVisible = true;
            this.passwordForm.password = res.data.data;
          } else {
            this.$message({
              message: `${res.data.msg}`,
              type: "warning"
            });
          }
        });
    },
    handleSelectionChange(val) {
      this.choiceList = val;
      this.recoveryList = val;
      this.toJdyList = val;
    },
    // 获取部门资源树形
    async getTree() {
      let params = {};
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptTree = res.data.data;
        // console.log(this.deptTree);

        this.treeData = res.data.data;
        if (this.treeData.length) {
          this.curdeptId = this.treeData[0].id;
          this.formData.deptId = this.curdeptId;
        }
      }
    },
    // 启用
    async enableUser() {
      if (!this.choiceList.length) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        });
        return false;
      }
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      let params = {
        ids: ids,
        status: 1
      };
      const res = await UserSwitch(params);
      if (res.data.code == 200) {
        this.$message({
          message: "启用成功",
          type: "success"
        });
        this.queryDictionaries();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 禁用用户
    async disableUser() {
      if (!this.choiceList.length) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        });
        return false;
      }
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      let params = {
        ids: ids,
        status: 2
      };
      const res = await UserSwitch(params);
      if (res.data.code == 200) {
        this.$message({
          message: "禁用成功",
          type: "success"
        });
        this.queryDictionaries();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 查询部门下拉列表
    async getDepartment() {
      const res = await getDeptArray();
      if (res.data.code == 200) {
        this.DepartmentList = res.data.data;
      }
    },
    // 查询角色下拉列表
    async getrole() {
      const res = await getRoleArray();
      if (res.data.code == 200) {
        res.data.data.map(item => {
          this.roleList.push({ id: item.id, value: item.value });
          this.roleData.push({
            label: item.value,
            key: item.id,
            type: item.type,
            disabled: false
          });
        });
      }
    },
    GetUser(val) {
      this.viewFormData.status = val.status;
      this.viewFormData.accountName = val.accountName;
      this.viewFormData.userName = val.userName;
      this.viewFormData.password = val.password;
      this.viewFormData.deptId = val.deptId;
      this.viewFormData.mail = val.mail;
      this.viewFormData.idNo = val.idNo;
      this.viewFormData.phone = val.phone;
      // this.viewFormData.userType = val.userType;
      this.viewFormData.remark = val.remark;
      console.log(this.viewFormData);
      this.visible = true;
    },
    async getValueDialog(val) {
      this.isWord = false;
      this.dialogVisible = true;
      this.isdisabled = true;
      this.title = "编辑用户信息";
      this.formData.accountName = val.accountName;
      this.formData.idType = val.idType + "";
      // this.formData.zcUserType = val.zcUserType;
      this.formData.zcWorkStatus = val.zcWorkStatus;
      this.formData.zcUserType = val.zcUserType;
      this.formData.zcWorkPosition = val.zcWorkPosition;
      this.formData.zcMainDuty = val.zcMainDuty;
      this.formData.userName = val.userName;
      this.formData.password = val.password;
      this.formData.deptId = val.deptId;
      this.formData.phone = val.phone;
      this.formData.idNo = val.idNo;
      this.formData.email = val.email;
      this.formData.remark = val.remark;
      this.formData.eiZfFlag = val.eiZfFlag;
      this.formData.eiZfzh = val.eiZfzh;
      this.formData.eiUserType = val.eiUserType;
      this.formData.id = val.id;
    },
    // 删除用户
    async deleteType(val) {
      if ((this.total - 1) % this.page.size === 0) {
        if (this.page.page > 1) {
          this.page.page -= 1;
        }
      }
      this.$axios
        .delete(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/user/delete/${val.id}`
        )
        .then(res => {
          if (res.data.code == 200) {
            this.queryDictionaries();
          }
        });
    },
    async cancelcerat() {
      let xx = true;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      if (this.isWord == true) {
        let params = {
          accountName: this.formData.accountName,
          idType: this.formData.idType,
          zcUserType: "gov",
          zcWorkStatus: this.formData.zcWorkStatus,
          zcUserType: this.formData.zcUserType,
          zcWorkPosition: this.formData.zcWorkPosition,
          zcMainDuty: this.formData.zcMainDuty,
          userName: this.formData.userName,
          password: this.encryptByAES(this.formData.password, this.key),
          deptId: this.formData.deptId,
          userType: this.formData.userType,
          phone: Number(this.formData.phone),
          idNo: this.formData.idNo,
          email: this.formData.email,
          remark: this.formData.remark,
          eiZfFlag: this.formData.eiZfFlag,
          eiZfzh: this.formData.eiZfzh,
          eiUserType: this.formData.eiUserType,
          id: this.formData.id,
          ghUserType: this.formData.ghUserType
        };
        const res = await setUserSave(params);
        if (res.data.code == 200) {
          this.formData.accountName = null;
          this.formData.userName = null;
          this.formData.eiZfFlag = 0;
          this.formData.eiZfzh = null;
          this.formData.eiUserType = null;
          this.formData.password = null;
          this.formData.deptId = null;
          this.formData.phone = null;
          this.formData.idNo = null;
          this.formData.email = null;
          this.formData.remark = null;
          this.formData.id = null;
          this.formData.idType = null;
          this.formData.zcUserType = null;
          this.formData.zcWorkStatus = null;
          this.formData.zcUserType = null;
          this.formData.zcWorkPosition = null;
          this.formData.zcMainDuty = null;

          this.queryDictionaries();
          this.dialogVisible = false;
          this.$message({
            message: "创建成功",
            type: "success"
          });
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: "warning"
          });
        }
      } else {
        let params = {
          accountName: this.formData.accountName,
          idType: this.formData.idType,
          zcUserType: "gov",
          zcWorkStatus: this.formData.zcWorkStatus,
          zcUserType: this.formData.zcUserType,
          zcWorkPosition: this.formData.zcWorkPosition,
          zcMainDuty: this.formData.zcMainDuty,
          userName: this.formData.userName,
          password: this.formData.password,
          deptId: this.formData.deptId,
          userType: this.formData.userType,
          phone: Number(this.formData.phone),
          idNo: this.formData.idNo,
          email: this.formData.email,
          remark: this.formData.remark,
          eiZfFlag: this.formData.eiZfFlag,
          eiZfzh: this.formData.eiZfzh,
          eiUserType: this.formData.eiUserType,
          ghUserType: this.formData.ghUserType,
          id: this.formData.id
        };
        const res = await setUserSave(params);
        if (res.data.code == 200) {
          this.formData.accountName = null;
          this.formData.userName = null;
          this.formData.password = null;
          this.formData.deptId = null;
          // this.formData.userType = "";
          this.formData.phone = null;
          this.formData.idNo = null;
          this.formData.email = null;
          this.formData.remark = null;
          this.formData.id = null;
          this.formData.eiZfzh = null;
          this.formData.eiUserType = null;
          this.formData.eiZfFlag = 0;
          this.formData.idType = null;
          this.formData.zcUserType = null;
          this.formData.zcWorkStatus = null;
          this.formData.zcUserType = null;
          this.formData.zcWorkPosition = null;
          this.formData.zcMainDuty = null;
          this.queryDictionaries();
          this.$message({
            message: "编辑成功",
            type: "success"
          });
          this.dialogVisible = false;
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: "warning"
          });
        }
      }
    },
    getchildeditDialog() {
      this.title = "新增用户";
      this.isWord = true;
      this.isdisabled = false;
      this.formData.accountName = null;
      this.formData.userName = null;
      this.formData.password = null;
      this.formData.deptId = this.curdeptId;
      // this.formData.userType = "";
      this.formData.phone = null;
      this.formData.idNo = null;
      this.formData.email = null;
      this.formData.remark = null;
      this.formData.eiZfzh = null;
      this.formData.eiUserType = null;
      this.formData.status = 1;
      this.formData.id = null;
      this.formData.eiZfFlag = 0;
      this.formData.idType = null;
      this.formData.zcUserType = null;
      this.formData.zcWorkStatus = null;
      this.formData.zcUserType = null;
      this.formData.zcWorkPosition = null;
      this.formData.zcMainDuty = null;
      this.dialogVisible = true;
    },
    getchildeditDialogTwo() {
      this.ruleFormTwo.itemLabel = "";
      this.ruleFormTwo.itemName = "";
      this.ruleFormTwo.status = 1;
      this.ruleFormTwo.remark = "";
      this.ruleFormTwo.id = "";
      this.titleTwo = "添加字典项数据";
      this.ruleFormTwo.dictType = this.formData.dictType;
      this.dialogVisibleTwo = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.queryDictionaries();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.queryDictionaries();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.Size = 10;
      this.currentPage = 1;
      this.queryDictionaries();
    },
    // 查询用户列表
    async queryDictionaries() {
      let params = {
        deptId: this.form.deptId,
        roleId: this.form.roleId,
        accountName: this.form.accountName,
        userName: this.form.userName,
        phone: this.form.phone,
        page: this.page.page,
        size: this.page.size,
        status: this.form.status,
        queryRole: true,
        zcUserTypeLike: "gov"
      };
      const res = await getUserList2(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        this.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
    // 导出用户数据
    async handleExportUserInfo() {
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      const params = {
        ...this.form,
        selUserIds: ids
      };
      // const res = await expUserList(params);
      const res = await expUserList(params);
      console.log("res :>> ", res);
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "用户数据.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },

    async getUserDetailFun(id) {
      const res = await getUserDetail(id);
      this.getValueDialog(res.data.data);
    },
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/template/社区工作管理平台人员信息收集表.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute(
              "download",
              "社区工作管理平台人员信息收集表.xlsx"
            );
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 重置
    onReset() {
      this.form = {
        deptId: "",
        accountName: "",
        roleId: "",
        userName: "",
        phone: "",
        status: null
      };
      if (this.treeData.length) {
        this.curdeptId = this.treeData[0].id;
        this.formData.deptId = this.curdeptId;
      }
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(null);
      });
      this.onSearch();
    }
  }
};
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
  display: flex;
}

.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
}

.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #b2b3c9;
  line-height: 21px;
  display: flex;
  align-items: center;
}

.box-header-right {
  font-weight: 400;
  color: #004ad1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

.left-tree {
  width: 300px;
  padding: 0 0 30px 0;
  height: 800px;
  overflow-y: scroll;
  margin-right: 20px;
  position: relative;

  /deep/.el-tree-node.is-current {
    // background: rgba(5, 141, 255, 0.1);
    // color: #008bff;
    > .el-tree-node__content {
      background: rgba(5, 141, 255, 0.1);
      color: #008bff;
    }
  }

  /deep/.el-tree-node__content {
    line-height: 36px;
    height: 36px;
  }

  /deep/.el-tree-node__content:hover {
    background: rgba(5, 141, 255, 0.1);
    color: #008bff;
  }
}

.section {
  width: calc(100% - 400px);
  height: 94.9%;
  background-color: #fff;
  padding: 30px 0;
}

.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}

.el-menu-item:hover {
  color: #1e90ff;
}

.daohang {
  display: flex;
  margin-left: 15px;
}

.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  // height: 70px;
  // flex-wrap: wrap;
  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.biaodan-left .el-form-item {
  margin-bottom: 0px;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}

.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}

/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}

.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-item {
  display: flex;
  justify-content: left;
}

.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}

/deep/.el-upload__input {
  display: none;
}

.botton-box {
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}

.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}

//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}

.black {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px !important;
}

.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}

.passWordForm {
  .el-form-item__content {
    width: 70%;
    display: flex !important;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -43px;
    margin-left: 95px;
  }
}

.updatePassword {
  width: 70px;
  height: 36px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: #0495ff;
  border-radius: 10%;
}

#character {
  .el-dialog {
    height: 860px;
    overflow: scroll;
  }

  .el-form-item__label {
    width: 95px;
  }

  .Permission_form {
    display: flex;
    justify-content: space-around;

    .el-form-item__content {
      width: 78.5%;
      height: 45px;
    }
  }

  .div-tag {
    width: auto;
    display: inline-block;
    position: relative;
    bottom: 41px;
    left: 4px;
    height: 40px;
    max-width: 450px;
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
  }

  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }

  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .character .el-dialog__body .data-d {
    height: 345px;
  }

  .pass {
    .el-dialog {
      margin-top: 33vh !important;
      width: 23% !important;
      height: 433px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
}

/deep/.v-modal {
  z-index: 2000 !important;
}

.user-dialog {
  .el-form-item {
    margin-bottom: 10px;
    width: 45% !important;
  }
}

.character .el-dialog__body form {
  padding-bottom: 0;
}

.tree-option {
  height: auto;
}

.tree-class .el-tree-node__content {
  &:hover {
    background-color: #dfeafb;
  }
}

.el-message {
  z-index: 2222 !important;
}

.tree-d {
  .el-form-item__content {
    position: relative;

    & > .el-input {
      position: absolute;
      z-index: 2;
    }
  }
}

.word {
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    margin-left: 25px;
  }
}

.guanlian {
  margin-left: 88px;
}

.aside .el-button {
  padding: 0;
}

// @media screen and (max-width: 1855px) {
//   .biaodan2 {
//     height: 100px;
//   }
// }
/deep/ .xiugai .el-input__inner {
  width: 150px;
  height: 28px;
  line-height: 28px;
}
.user-form {
  /deep/.el-form {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/.el-form-item {
    width: 48%;
    .el-form-item__label {
      margin: 0;
      padding: 0;
    }
  }
  /deep/.el-form-item:nth-of-type(odd) {
    margin-right: 12px;
  }
}
.roleLabel {
  color: #606266;
  font-size: 16px;
  font-weight: 800;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/zwList.vue